import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropState } from 'src/app/shared/models';

import { adapter } from '../reducers/most-used-crop.reducer';

const { selectAll } = adapter.getSelectors();
const getMostUsedCropState = createFeatureSelector<CropState>('most-used-crops');
export const getMostUsedCrops = createSelector(getMostUsedCropState, selectAll);
